/**
 * Client-portal helpers for session-recording Consent reads (Settings).
 */
import type { MedplumClient } from '@medplum/core';
import type { Consent } from '@medplum/fhirtypes';
import {
  CONSENT_CATEGORY_SYSTEM,
  SESSION_RECORDING_CONSENT_CATEGORY_CODE,
} from '@unify/fhir-model/constants';
import {
  resolveCurrentSessionRecordingDecision,
  type SessionRecordingDecision,
} from '@unify/fhir-model/resources/consent';

export async function searchAllSessionRecordingConsentsForPatient(
  medplum: MedplumClient,
  patientId: string,
): Promise<Consent[]> {
  medplum.invalidateSearches('Consent');
  const category = `${CONSENT_CATEGORY_SYSTEM}|${SESSION_RECORDING_CONSENT_CATEGORY_CODE}`;
  const pageSize = 100;
  const all: Consent[] = [];
  for (let offset = 0; ; offset += pageSize) {
    const page = await medplum.searchResources('Consent', {
      patient: `Patient/${patientId}`,
      category,
      _count: String(pageSize),
      _offset: String(offset),
    });
    all.push(...page);
    if (page.length < pageSize) break;
  }
  return all;
}

export async function loadSessionRecordingDecision(
  medplum: MedplumClient,
  patientId: string,
): Promise<SessionRecordingDecision> {
  const consents = await searchAllSessionRecordingConsentsForPatient(medplum, patientId);
  return resolveCurrentSessionRecordingDecision(consents, patientId).decision;
}
